import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { AddIcon } from "../../../../../data/iconImage";
import { findItemBySearch } from "../../../../../utils/ManageArray";
import { FloatingControlComponent } from "../../../../../components/FormComponent";
import Table from "../../../../../components/Table";
import ButtonLink from "../../../../../components/ButtonLink";
import SearchFilter from "../../../../../components/SearchFilter";
import CardDisplayComponent from "../../../../../components/CardDisplayComponent";

const BomsTab = ({ data, columns, loading }) => {
  const [SubBoms, setSubBoms] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const searchInput = [
    {
      name: "ParentBom.Item.Item_Code",
      label: "รหัสสินค้า",
      filterBy: ["ParentBom.Item.Item_Code"]
    },
    {
      name: "ParentBom.Item.Item_Name_TH",
      label: "ชื่อสินค้า",
      size: 4,
      filterBy: ["ParentBom.Item.Item_Name_TH"]
    },
    {
      name: "ParentBom.Bom_Type",
      label: "ชนิด BOM",
      size: 2,
      noneAsync: true,
      filterBy: ["Bom_Type"]
    }
  ];
  const actionButton = [
    { to: "create", label: "สร้าง BOM", color: "success" },
    { to: "edit", label: "แก้ไข BOM", color: "outline-secondary" },
    { to: "delete", label: "ลบ BOM", color: "outline-secondary" },
    { to: "copy", label: "คัดลอก BOM", color: "outline-secondary" }
  ];

  useEffect(() => {
    if (selectedRows?.length > 0) {
      setSubBoms(
        data.SubBom.filter(({ Child_Bom_Id }) =>
          selectedRows.some(({ Id }) => Child_Bom_Id === Id)
        )
      );
    }
  }, [selectedRows]);

  return (
    <>
      <CardDisplayComponent
        body={{
          element: (
            <SearchFilter
              data={data.Child}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto py-2" }}
              searchCallback={(search) =>
                setSearchValue(search.some(({ value }) => value) ? search : [])
              }
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{
          title: { text: "รายละเอียด BOM" },
          className: "d-flex out justify-content-between align-items-center",
          button: (
            <Row>
              {actionButton.map(({ to, label, color }, index) => (
                <Col key={index} sm={2} className="w-auto ps-2">
                  <ButtonLink
                    linkTo={to}
                    stateData={{ type: "Bom", sub: "Child" }}
                    buttonName={label}
                    buttonColor={color}
                    buttonClass="py-2 px-4 text-dark rounded-pill"
                    iconSrc={color === "success" ? AddIcon : null}
                    iconClass="me-2 mb-1"
                    iconName="Add Icon"
                  />
                </Col>
              ))}
            </Row>
          )
        }}
        body={{
          element: (
            <>
              {searchValue?.length > 0 && (
                <Row>
                  {[
                    { name: "Item_Code", label: "รหัสสินค้า", size: 4 },
                    { name: "Item_Name_TH", label: "ชื่อสินค้า", size: 8 }
                  ].map(({ name, label, size }, idx) => {
                    const value = findItemBySearch(data?.Child, searchValue)
                      ?.ParentBom?.Item?.[name];

                    return (
                      <Col key={idx} sm={size} className="mb-3 ">
                        <FloatingControlComponent
                          disabled
                          name={name}
                          label={label}
                          className={{ label: "mb-3" }}
                          value={value}
                        />
                      </Col>
                    );
                  })}
                </Row>
              )}

              <Table
                data={data.Child}
                column={columns.Child}
                searchFilter={searchValue}
                pending={loading}
                pagination
                selectableRows
                selectableRowsSingle
                onSelectedRowsChange={({ selectedRows }) =>
                  setSelectedRows(selectedRows)
                }
              />
            </>
          )
        }}
      />

      {SubBoms?.length > 0 && (
        <CardDisplayComponent
          header={{ title: { text: "รายละเอียด SUB BOM" } }}
          body={{
            element: (
              <Table
                data={SubBoms}
                column={columns.SubBom}
                pending={loading}
                pagination
              />
            )
          }}
        />
      )}
    </>
  );
};

BomsTab.propTypes = {
  data: PropTypes.object,
  columns: PropTypes.object,
  loading: PropTypes.bool
};

export default BomsTab;
